import styled from 'styled-components';

import { Button } from '@/ui/Button';
import { makeNamespacedComponent } from '@/ui/utils/makeNamespacedComponent';
import { Skeleton } from '@/ui/Skeleton';
import { LearningCardProps, LearningCard } from '@/administration/pages/Journey/common/atoms/LearningCard/LearningCard';
import { PARENT_JOURNEY_ID_SEARCH_KEY } from '@/store/v2/journeys/useLearningJourneyBreadcrumbs';

const RootStyled = styled.div`
  padding: 32px;
  border: 1px solid ${({ theme }) => theme.colors.neutral.outline1};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const TitleStyled = styled.h3`
  ${({ theme }) => theme.typography.title3};
  color: ${(p) => p.theme.colors.neutral.onBackground};
`;

const MetaBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

type JourneyViewUpcomingEventBoxProps = {
  item: LearningCardProps;
  journeyId?: number;
  onPreJoinItemClick?: () => void;
};

const JourneyViewUpcomingEventBox = ({
  item,
  journeyId,
  onPreJoinItemClick,
}: JourneyViewUpcomingEventBoxProps): React.ReactElement => {
  const viewDetailsProps = onPreJoinItemClick
    ? { onClick: onPreJoinItemClick }
    : {
        to: {
          pathname: item.launchPath || '',
          search: journeyId ? `${PARENT_JOURNEY_ID_SEARCH_KEY}=${journeyId}` : '',
        },
      };

  return (
    <RootStyled>
      <TitleStyled>Upcoming event</TitleStyled>
      <MetaBlockStyled>
        <LearningCard {...item} variant="compact" />
        <Button variant="secondary" icon="arrow-right" $iconPosition="end" {...viewDetailsProps}>
          View details
        </Button>
      </MetaBlockStyled>
    </RootStyled>
  );
};

const LoadingState = () => <Skeleton height={250} />;

const _JourneyViewUpcomingEventBox = makeNamespacedComponent(JourneyViewUpcomingEventBox, {
  LoadingState,
});

export { _JourneyViewUpcomingEventBox as JourneyViewUpcomingEventBox };
